import { render, staticRenderFns } from "./ListSaleIcon.vue?vue&type=template&id=21fb5110&"
import script from "./ListSaleIcon.vue?vue&type=script&lang=js&"
export * from "./ListSaleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports